import TagManager from 'react-gtm-module';

export enum EventName {
  clickCategoryNavigation = 'click_category_navigation',
}

interface TrackNavEventProps {
  data: {
    eventName: EventName;
    linkUrl: string | null;
    linkText: string;
  };
}

export const trackNavClick = ({ data }: TrackNavEventProps) => {
  const { eventName, linkUrl, linkText } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: eventName,
      interaction: {
        ...(linkUrl !== null && { link_url: linkUrl }),
        ...(linkText && { link_text: linkText }),
      },
    },
  });
};
